import {ServiceConfigurationV1} from "@volkswagen-onehub/service-config-provider";

export const getCustomConfig = (serviceConfig: ServiceConfigurationV1 | undefined): any => {
    if (serviceConfig && serviceConfig.customConfig) {
        return (serviceConfig.customConfig as any);
    } else {
        return {};
    }
};

export const getUrlOrigin = (serviceConfig: ServiceConfigurationV1 | undefined): string => {
    return serviceConfig ? serviceConfig.urlOrigin : '';
};

export const getFeatureToggle = (serviceConfig: ServiceConfigurationV1 | undefined, toggleName: string): boolean => {
    return !!getCustomConfig(serviceConfig)[toggleName];
};

